import React, { useState, useEffect } from 'react';
import dealImage3 from './assets/images/deal3.png';
import dealImage2 from './assets/images/deal2.png';
import dealImage1 from './assets/images/deal1.png';

import qrImage3 from './assets/images/qr3.png';
import qrImage2 from './assets/images/qr2.png';
import qrImage1 from './assets/images/qr1.png';

import AppBanner from './components/AppBanner';
import Popup from './components/Popup';

import './App.css';

const deals = [
    {
        id: 1,
        title: 'MEDIUM MILKSHAKE',
        startDate: new Date('2025-12-01T00:00:00+01:00'),
        endDate: new Date('2025-12-15T23:59:59+01:00'),
        image: dealImage1,
        qrImage: qrImage1,
        desktopMargin: '-60px 0 -40px',
        mobileMargin: '-40px 0 00px',
        dealText: 'Deze Deal is alléén geldig van 1 t/m 15 december 2025 bij deelnemende McDonald\'s restaurants.'
    },
    {
        id: 2,
        title: '20 McNUGGETS',
        startDate: new Date('2025-12-16T00:00:00+01:00'),
        endDate: new Date('2025-12-22T23:59:59+01:00'),
        image: dealImage2,
        qrImage: qrImage2,
        desktopMargin: '-100px 0 -40px',
        mobileMargin: '-40px 0 0px',
        dealText: 'Deze Deal is alléén geldig van 16 t/m 22 december 2025 bij deelnemende McDonald\'s restaurants.'
    },
    {
        id: 3,
        title: '1X KLASSIEKE BURGER',
        startDate: new Date('2025-12-23T00:00:00+01:00'),
        endDate: new Date('2025-12-30T23:59:59+01:00'),
        image: dealImage3,
        qrImage: qrImage3,
        desktopMargin: '-100px 0 -40px',
        mobileMargin: '-60px 0 0px',
        dealText: 'Deze Deal is alléén geldig van 23 t/m 30 december 2025 bij deelnemende McDonald\'s restaurants.'
    },
];

function App() {
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [activeDeal, setActiveDeal] = useState(null);
    const [dayIndex, setDayIndex] = useState(0);

    const getActiveDeal = (currentDate) => {
        const date = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
        setDayIndex(+((currentDate && currentDate.toISOString()) || date.toISOString()).slice(8, 10) - 1);
        return deals.find(deal => (currentDate || date) >= deal.startDate && (currentDate || date) <= deal.endDate);
    };

    useEffect(() => {
        const firstDealStartDate = deals.length > 0 ? deals[0].startDate : null;
        const realNow = new Date();
        let simulatedDate = null;

        if (firstDealStartDate && realNow < firstDealStartDate) {
            const urlParams = new URLSearchParams(window.location.search);
            const timestamp = urlParams.get('timestamp');
            if (timestamp) {
                simulatedDate = new Date(timestamp);
            }
        }

        setActiveDeal(getActiveDeal(simulatedDate));
    }, []);

    const handleShowPopup = () => {
        if (activeDeal) {
            setPopupVisible(true);
        }
    };

    const handleClosePopup = () => {
        setPopupVisible(false);
    };

    if (!activeDeal) {
        return (
            <div className="App" style={{ alignItems: 'center' }}>
                <div className="coupon-container"  style={{ padding: 0 }}>
                    <h1 className="main-title">Geen deal beschikbaar</h1>
                    <p className="deal-text">Kom later terug voor meer aanbiedingen.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="App">
            <div className="coupon-container">
                <p className="deal-text">DECEMBER DEAL</p>
                <h1 className="main-title">{activeDeal.title}</h1>

                <img
                    alt={activeDeal.title}
                    src={activeDeal.image}
                    className="burger-image"
                    style={{
                        '--desktop-margin': activeDeal.desktopMargin,
                        '--mobile-margin': activeDeal.mobileMargin
                    }}
                />

                <button className="deal-button" onClick={handleShowPopup}>
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.7935 11.0344V13.793" stroke="url(#paint0_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.0347 2.75854V5.51717" stroke="url(#paint1_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.5518 11.0344V13.793" stroke="url(#paint2_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.0347 16.5515H19.3105" stroke="url(#paint3_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.5518 19.3103H19.3104" stroke="url(#paint4_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.51758 11.0344H8.2762" stroke="url(#paint5_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.51758 5.52635L5.52591 5.51709" stroke="url(#paint6_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.0347 11.0437L11.043 11.0344" stroke="url(#paint7_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.75879 11.0437L2.76712 11.0344" stroke="url(#paint8_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.0347 8.28514L11.043 8.27588" stroke="url(#paint9_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.0347 13.8022L11.043 13.793" stroke="url(#paint10_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.7935 19.3196L13.8018 19.3103" stroke="url(#paint11_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.0347 19.3196L11.043 19.3103" stroke="url(#paint12_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.3105 11.0437L19.3189 11.0344" stroke="url(#paint13_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.3105 13.8022L19.3189 13.793" stroke="url(#paint14_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.5518 5.52635L16.5601 5.51709" stroke="url(#paint15_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.27603 3.31027V7.72406C8.27603 8.02877 8.02901 8.27579 7.72431 8.27579H3.31051C3.00581 8.27579 2.75879 8.02877 2.75879 7.72406V3.31027C2.75879 3.00556 3.00581 2.75854 3.31051 2.75854H7.72431C8.02901 2.75854 8.27603 3.00556 8.27603 3.31027Z" stroke="url(#paint16_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.3107 3.31027V7.72406C19.3107 8.02877 19.0637 8.27579 18.759 8.27579H14.3452C14.0404 8.27579 13.7935 8.02877 13.7935 7.72406V3.31027C13.7935 3.00556 14.0404 2.75854 14.3452 2.75854H18.759C19.0637 2.75854 19.3107 3.00556 19.3107 3.31027Z" stroke="url(#paint17_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.51758 16.5608L5.52591 16.5515" stroke="url(#paint18_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.27603 14.3447V18.7585C8.27603 19.0632 8.02901 19.3102 7.72431 19.3102H3.31051C3.00581 19.3102 2.75879 19.0632 2.75879 18.7585V14.3447C2.75879 14.04 3.00581 13.793 3.31051 13.793H7.72431C8.02901 13.793 8.27603 14.04 8.27603 14.3447Z" stroke="url(#paint19_linear_8859_706)" stroke-width="1.32414" stroke-linecap="round" stroke-linejoin="round"/>
                        <defs>
                            <linearGradient id="paint0_linear_8859_706" x1="14.2935" y1="11.0344" x2="14.2935" y2="13.793" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint1_linear_8859_706" x1="11.5347" y1="2.75854" x2="11.5347" y2="5.51717" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint2_linear_8859_706" x1="17.0518" y1="11.0344" x2="17.0518" y2="13.793" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint3_linear_8859_706" x1="15.1726" y1="16.5515" x2="15.1726" y2="17.5515" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint4_linear_8859_706" x1="17.9311" y1="19.3103" x2="17.9311" y2="20.3103" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint5_linear_8859_706" x1="6.89689" y1="11.0344" x2="6.89689" y2="12.0344" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint6_linear_8859_706" x1="5.52174" y1="5.51709" x2="5.52174" y2="5.52635" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint7_linear_8859_706" x1="11.0388" y1="11.0344" x2="11.0388" y2="11.0437" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint8_linear_8859_706" x1="2.76296" y1="11.0344" x2="2.76296" y2="11.0437" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint9_linear_8859_706" x1="11.0388" y1="8.27588" x2="11.0388" y2="8.28514" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint10_linear_8859_706" x1="11.0388" y1="13.793" x2="11.0388" y2="13.8022" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint11_linear_8859_706" x1="13.7976" y1="19.3103" x2="13.7976" y2="19.3196" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint12_linear_8859_706" x1="11.0388" y1="19.3103" x2="11.0388" y2="19.3196" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint13_linear_8859_706" x1="19.3147" y1="11.0344" x2="19.3147" y2="11.0437" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint14_linear_8859_706" x1="19.3147" y1="13.793" x2="19.3147" y2="13.8022" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint15_linear_8859_706" x1="16.5559" y1="5.51709" x2="16.5559" y2="5.52635" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint16_linear_8859_706" x1="5.51741" y1="2.75854" x2="5.51741" y2="8.27579" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint17_linear_8859_706" x1="16.5521" y1="2.75854" x2="16.5521" y2="8.27579" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint18_linear_8859_706" x1="5.52174" y1="16.5515" x2="5.52174" y2="16.5608" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                            <linearGradient id="paint19_linear_8859_706" x1="5.51741" y1="13.793" x2="5.51741" y2="19.3102" gradientUnits="userSpaceOnUse">
                                <stop stop-color="white"/>
                                <stop offset="1" stop-color="#FAFAFA"/>
                            </linearGradient>
                        </defs>
                    </svg>

                    <span>IK WIL DEZE DEAL</span>
                </button>

                <span className="validity-text">{activeDeal.dealText}</span>
            </div>

            <AppBanner day={dayIndex} />

            <Popup
                isVisible={isPopupVisible}
                onClose={handleClosePopup}
                deal={activeDeal}
            />
        </div>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js